import { gql } from "@apollo/client";

export const programsQuery = gql`
  query programs($scenarioId: ID!, $filter: ProgramFilterInput) {
    data(scenarioId: $scenarioId) {
      programs(filter: $filter) {
        items {
          id
          code
          name
          campus {
            id
            name
            code
            __typename
          }
          department {
            id
            name
            code
            __typename
          }
          shift {
            id
            name
            code
            __typename
          }
          modality {
            id
            name
            code
            __typename
          }
        }
        pageInfo {
          hasPreviousPage
          hasNextPage
          page
          size
          total
        }
      }
    }
  }
`;
